/**
 * Build a 実践メモ card model for 改善相談 (Kuroco mock parity).
 * Prefer PRACTICE_MEMO from the API; fall back to ACTIONS[i] when/what/howMuch.
 */

const CIRCLED = ['①', '②', '③', '④', '⑤'];

/**
 * @param {object|null|undefined} practiceMemo - from assistant_message.practice_memo
 * @param {Array<object>|null|undefined} actions - pending_proposal.actions
 * @param {{ nextMonthLabel?: string }} [opts]
 * @returns {{ actionIndex: number, circled: string, title: string, timing: string, target: string, script: string, tip: string, nextMonthLabel: string }|null}
 */
export function buildPracticeMemoCard(practiceMemo, actions, opts = {}) {
  const list = Array.isArray(actions) ? actions.filter((a) => a?.name) : [];
  const nextMonthLabel = opts.nextMonthLabel || '';

  let actionIndex = 0;
  if (practiceMemo && Number.isFinite(Number(practiceMemo.actionIndex))) {
    actionIndex = Math.trunc(Number(practiceMemo.actionIndex));
  } else if (list.length >= 2) {
    actionIndex = 2; // mock focuses ②
  } else if (list.length === 1) {
    actionIndex = 1;
  } else {
    return null;
  }
  if (actionIndex < 1 || actionIndex > CIRCLED.length) return null; // plan has up to 5 rows

  const action = list[actionIndex - 1] || null;
  const title = (action?.name || practiceMemo?.title || '').trim();
  if (!title && !practiceMemo) return null;

  const timing =
    String(practiceMemo?.timing || action?.when || action?.timing || '').trim() || '—';
  const target =
    String(practiceMemo?.target || action?.target || '').trim() || '関連するお客様';
  const script =
    String(practiceMemo?.script || action?.script || action?.what || '').trim() || '—';
  const tip =
    String(practiceMemo?.tip || action?.tip || action?.howMuch || '').trim() || '—';

  return {
    actionIndex,
    circled: CIRCLED[actionIndex - 1] || String(actionIndex),
    title: title || `行動${actionIndex}`,
    timing,
    target,
    script,
    tip,
    nextMonthLabel,
  };
}

/** Ensure mock chips exist after a 改善相談 turn (dedupe by keyword). */
export function mergeImproveChoices(choices) {
  const base = Array.isArray(choices) ? [...choices] : [];
  const ensure = [
    { chip: '📝 今日試して記録', match: /記録/ },
    { chip: '📊 当月実績を見る', match: /実績|振り返り/ },
  ];
  for (const { chip, match } of ensure) {
    if (!base.some((x) => match.test(String(x)))) base.push(chip);
  }
  return base;
}
